import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { unidades } from "@/constants/unidades"
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { LoaderCircle } from "lucide-react"
import { useState } from "react"

export function LoginForm({
  className,
  handleSubmit,
  loading,
  ...props
}) {
  // algumas unidades compartilham o id (login) de outra, então o Select usa o label
  // como valor para que cada opção seja selecionada individualmente
  const [unidadeLabel, setUnidadeLabel] = useState("")
  const empresaId = unidades.options.find(emp => emp.label === unidadeLabel)?.id || ""

  return (
    <div className={cn("flex flex-col gap-6", className)} {...props}>
      <Card>
        <CardHeader className="text-center">
          <CardTitle className="text-xl">Iniciar sessão</CardTitle>
          <CardDescription className="text-[12px]">
            Para entrar utilize as mesmas credencias do sistema Sponte!
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit}>
            <div className="grid gap-6">
              <div className="grid gap-6">
                <div className="grid gap-2">
                  <Label htmlFor="email">Email</Label>
                  <Input
                    id="email"
                    name="email"
                    type="email"
                    placeholder="email@redeprocursos.com.br"
                    required
                  />
                </div>
                <div className="grid gap-2">
                  <Label htmlFor="cpf">CPF</Label>
                  <Input
                    id="cpf"
                    name="cpf"
                    type="tel"
                    placeholder="###########"
                    required
                  />
                </div>
                <div className="grid gap-2">
                  <Label htmlFor="empresa">Empresa</Label>
                  <input type="hidden" name="empresa" value={empresaId} />
                  <Select id="empresa" value={unidadeLabel} onValueChange={setUnidadeLabel}>
                    <SelectTrigger className="w-full">
                      <SelectValue placeholder="Selecione uma empresa..." />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectGroup>
                        {unidades.options.map(emp => (
                          <SelectItem key={emp.label} value={emp.label}>{emp.label}</SelectItem>
                        ))}
                      </SelectGroup>
                    </SelectContent>
                  </Select>
                </div>
                <Button type="submit" className="w-full" disabled={loading}>
                  {loading && <LoaderCircle className="animate-spin text-slate-50 size-5" />}
                  Entrar
                </Button>
              </div>
            </div>
          </form>
        </CardContent>
      </Card>
      <div className="text-balance text-center text-xs text-muted-foreground [&_a]:underline [&_a]:underline-offset-4 [&_a]:hover:text-primary  ">
        © 2025 Rede Procursos. Todos os direitos reservados.
      </div>
    </div>
  )
}
